export let DomainsPermissions = /*#__PURE__*/function (DomainsPermissions) {
  DomainsPermissions["AccountLevelPurchaseDomain"] = "premium.purchaseDomain";
  DomainsPermissions["AccountLevelManageDomains"] = "premium.manageDomains";
  DomainsPermissions["SiteLevelManageDomains"] = "my-account.connect-domain";
  DomainsPermissions["SiteLevelPurchaseDomain"] = "premium.DomainsPurchasePageController.domainPurchasePage.siteLevel";
  return DomainsPermissions;
}({});
//# sourceMappingURL=domainPermissions.js.map